import ExciseExceptions from './ExciseExceptions'
export default class LuExciseIssues {
  constructor(objIn = {}) {
    const defaults = {
      //ID is required
      ID: 0,
      //IssueNumber is required
      IssueNumber: 0,
      //Description is required
      Description: '',
      //Statute is required
      Statute: '',
      //RulesReg is required
      RulesReg: '',
      //SubjectToInterest is required
      SubjectToInterest: false,
      //IsActive is required
      IsActive: false,
    }
    let obj = {}
    Object.assign(obj, defaults, objIn)
    this.ID = obj.ID
    this.IssueNumber = obj.IssueNumber
    this.Description = obj.Description
    this.Statute = obj.Statute
    this.RulesReg = obj.RulesReg
    this.SubjectToInterest = obj.SubjectToInterest
    this.IsActive = obj.IsActive
    this.ExciseExceptions = []
    if (obj.ExciseExceptions) {
      obj.ExciseExceptions.forEach((item) => {
        this.ExciseExceptions.push(new ExciseExceptions(item))
      })
    }
  }
  removeRelated() {
    let obj = Object.assign({}, this)
    obj.ExciseExceptions = []
    if (this.ExciseExceptions) {
      this.ExciseExceptions.forEach((item) => {
        obj.ExciseExceptions.push(item.removeRelated())
      })
    }
    return obj
  }
  root() {
    let obj = Object.assign({}, this)
    obj.ExciseExceptions = null
    return obj
  }
}
